export enum RoleEnum{
    EMPLOYEE= "employee",
    EMPLOYER = "employer",
    ADMIN = "admin"
}